import TurnusStore from 'src/stores/TurnusStore';
import KlientStore from 'src/stores/KlientStore';
import DenStore from 'src/stores/DenStore';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Grid, Drawer, AppBar, Toolbar, IconButton, FormControl, InputLabel, Table, Select, MenuItem, TableHead, TableRow, TableCell, TableBody, Typography, TextField, Paper, List, ListItem, ListItemText, ListItemIcon, Fab, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { computed, observable, action } from 'mobx';
import NavigationDrawerItems from './NavigationDrawerItems';
import MenuIcon from '@material-ui/icons/Menu';
import { inject, observer } from 'mobx-react';
import 'src/assets/styles/index.css'
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';
import 'moment/locale/cs';
import Objednavka from 'src/models/Objednavka';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import Klient from 'src/models/Klient';
import Turnus from 'src/models/Turnus';
import { OrderHelper } from 'src/classes/OrderHelper';
import HistoryListing from 'src/components/HistoryListing';
import HistorieStore from 'src/stores/HistorieStore';
import FakturaceStore from 'src/stores/FakturaceStore';
import Faktura from 'src/models/Faktura';
import CiselnikyStore from 'src/stores/CiselnikyStore';
import AuthStore from 'src/stores/AuthStore';
import WebObjednavka from 'src/models/WebObjednavka';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';
import NovaObjednavka from 'src/models/NovaObjednavka';
import ClientNewDialog from './ClientNewDialog';

export interface IWebOrderDetailProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    denStore?: DenStore;
    objednavkaStore?: ObjednavkaStore;
    historieStore?: HistorieStore;
    fakturaceStore?: FakturaceStore;
    objednavkaId: number;
    ciselnikyStore?: CiselnikyStore;
    authStore?: AuthStore;
}

@inject('klientStore')
@inject('authStore')
@inject('fakturaceStore')
@inject('objednavkaStore')
@inject('turnusStore')
@inject('denStore')
@inject('historieStore')
@inject('ciselnikyStore')
@observer
class WebOrderDetail extends React.Component<IWebOrderDetailProps>{

    constructor(props: Readonly<IWebOrderDetailProps>) {
        super(props);
        console.log("LOAD: WebOrderDetail/" + props.objednavkaId);
    }

    // GUI state monitoring
    @observable private isDrawerOpened: boolean = false;
    @observable private isNewClientDialogOpened: boolean = false;

    // Data
    private orderBacking: WebObjednavka = null;
    @observable private clients: Klient[] = [];
    @observable private clientsSelected: Map<number, boolean> = new Map();
    @observable private begining: Date = new Date();
    @observable private program: string = 'none';
    @observable private pocet: string = '1';
    @observable private eko: boolean = false;
    @observable private clientTemplate: Klient = new Klient();

    @computed private get order(): WebObjednavka {
        if(this.orderBacking === null) {
            this.orderBacking = this.props.objednavkaStore.getWebObjednavkaByID(this.props.objednavkaId);
            const filter = new Klient();
            filter.telefon = this.orderBacking.telefon;
            filter.email = this.orderBacking.email;
            this.clients = this.props.klientStore.filterClients(filter);
            this.clients.forEach(cl => {
                console.log("WebOrderDetail: found matching client: " + cl.id + "-" + cl.getFullName())
                this.clientsSelected.set(cl.id, false);
            });

            const prgValue = this.parseProgram(this.orderBacking.program);
            const prg = this.props.ciselnikyStore.getLatestValidProgramByValue(prgValue);
            if(prg !== undefined) {
                this.program = prg.value.toString();
            }
            const datum = moment(this.orderBacking.zacatek, "DD.MM.YYYY", "cs");
            if(datum.isValid()) {
                this.begining = datum.toDate();
            }
            const turnPocet = parseInt(this.orderBacking.sleva, 10);
            if(turnPocet > 0 && turnPocet < 4) {
                this.pocet = turnPocet.toString();
            }
            if(this.orderBacking.program.includes("ECO")) {
                this.eko = true;
            }

            const clTemplate: Klient = new Klient();
            clTemplate.jmeno = this.orderBacking.jmeno;
            clTemplate.prijmeni = this.orderBacking.prijmeni;
            clTemplate.telefon = this.orderBacking.telefon;
            clTemplate.email = this.orderBacking.email;
            clTemplate.ulice = this.orderBacking.ulice;
            clTemplate.mesto = this.orderBacking.mesto;
            clTemplate.PSC = this.orderBacking.psc;
            this.clientTemplate = clTemplate;
        }
        return this.orderBacking;
    }

    private parseProgram = (prgString: string):number => {
        if(prgString.includes("5 000 kJ")) {return 5000};
        if(prgString.includes("6 000 kJ")) {return 6000};
        if(prgString.includes("7 000 kJ")) {return 7000};
        if(prgString.includes("8 000 kJ")) {return 8000};
        if(prgString.includes("9 000 kJ")) {return 9000};
        if(prgString.includes("10 000 kJ")) {return 10000};
        return undefined;
    }

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    };

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private getData(): Map<number, Turnus[]> {
        const retVal: Map<number, Turnus[]> = new Map();
        const turnusy: Turnus[] = this.props.turnusStore.getTurnusyByObjednavkaID(this.props.objednavkaId);
        turnusy.forEach(trns => {
            if(!retVal.has(trns.idKlient)) {
                retVal.set(trns.idKlient, []);
            }
            retVal.get(trns.idKlient).push(trns);
        });
        return retVal;
    }

    private handleMarkProcessed = () => {
        this.props.objednavkaStore.markWebOrderProcessed(this.order.id)
            .then(success => {
                this.props.history.push(`/web-orders`);
            });
    }

    private handleNewOrder = () => {
        const obj: NovaObjednavka = new NovaObjednavka();

        obj.webObjednavka = this.order.id;

        this.clientsSelected.forEach((val: boolean, key: number) => {
            if(val === true) {
                const klient: Klient = this.props.klientStore.getClientById(key);
                obj.klienti.push(klient);
                obj.turnusy.set(klient.id, []);
                obj.dny.set(klient.id, []);
                obj.slevy.set(klient.id, '-');
                obj.eko.set(klient.id, this.eko);
                obj.nekompletni.set(klient.id, false);
                obj.castecneMenu.set(klient.id, false);
            }
        });

        const prgValue = parseInt(this.program, 10);
        const prg = this.props.ciselnikyStore.getLatestValidProgramByValue(prgValue);
        const pocet = parseInt(this.pocet, 10);

        const turnus1: Turnus = new Turnus();
        turnus1.program = prg.id;
        turnus1.od = this.begining;
        turnus1.do = moment(this.begining).add(3, 'w').add(4, 'd').toDate();
        turnus1.rozsah = [];
        turnus1.rozsah.push('plny');

        obj.klienti.forEach(kl => {
            const trn: Turnus = turnus1.clone();
            trn.idKlient = kl.id;
            obj.turnusy.get(kl.id).push(trn);
        });

        if(pocet > 1) {
            const turnus2: Turnus = new Turnus();
            turnus2.program = prg.id;
            turnus2.od = moment(this.begining).add(4, 'w').toDate();
            turnus2.do = moment(this.begining).add(7, 'w').add(4, 'd').toDate();
            turnus2.rozsah = [];
            turnus2.rozsah.push('plny');

            obj.klienti.forEach(kl => {
                const trn: Turnus = turnus2.clone();
                trn.idKlient = kl.id;
                obj.turnusy.get(kl.id).push(trn);
            });
        }

        if(pocet > 2) {
            const turnus2: Turnus = new Turnus();
            turnus2.program = prg.id;
            turnus2.od = moment(this.begining).add(8, 'w').toDate();
            turnus2.do = moment(this.begining).add(11, 'w').add(4, 'd').toDate();
            turnus2.rozsah = [];
            turnus2.rozsah.push('plny');

            obj.klienti.forEach(kl => {
                const trn: Turnus = turnus2.clone();
                trn.idKlient = kl.id;
                obj.turnusy.get(kl.id).push(trn);
            });
        }

        this.props.objednavkaStore.orderTemplate = obj;
        this.props.history.push(`/neworder`);
    }

    @action
    private handleEntityDateValueChange = date => {
        this.begining = moment(date).toDate();
    }

    @action
    private handleClientCheckedChange = (klient, checked, unchecked) => event => {
        this.clientsSelected.set(klient, event.target.checked ? checked : unchecked);
    };

    @action
    private handleCheckedChange = (name, checked, unchecked) => event => {
        this[name] = event.target.checked ? checked : unchecked;
    };

    public handleNewClient = () => {
        this.isNewClientDialogOpened = true;
    }

    public onClientAdd = (client: Klient) => {
        console.log("WebOrderDetail: creating new client");
        const klient = this.props.klientStore.createNewClientSimple(client);
        klient.then(kl => {
            this.props.fakturaceStore.refreshSubjects()
            .then(success => {
                console.log("WebOrderDetail: new client created: " + kl.id);
                this.clientsSelected.set(kl.id, true);
                this.clients.push(kl);
                this.isNewClientDialogOpened = false;
            })
        });
    }

    public onClientDialogClose = () => {
        this.isNewClientDialogOpened = false;
    }

    public render() {
        return (
            this.order ?
                <div>
                    <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                        <NavigationDrawerItems />
                    </Drawer>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <AppBar position="static" >
                                <Toolbar>
                                    <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                        <MenuIcon />
                                    </IconButton>
                                    <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                        Webová Objednávka - {this.order.id} - {this.order.jmeno} {this.order.prijmeni}
                                    </Typography>
                                    <Button onClick={this.handleMarkProcessed} color="inherit">
                                        Označit jako zpracovanou
                                    </Button>
                                    <Button onClick={this.handleNewOrder} color="inherit">
                                        Založit
                                    </Button>
                                </Toolbar>
                            </AppBar>
                        </Grid>

                        <Grid item xs={12} style={{ margin: 8 }}>
                            <Grid container spacing={8}>
                                <Grid container item xs={6}>
                                    <Grid item xs={12}>
                                        <Paper square>
                                            <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                                <Toolbar variant="dense">
                                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                    Údaje z webu
                                                </Typography>
                                                </Toolbar>
                                            </AppBar>
                                            <Grid container spacing={8} style={{ marginLeft: 8, marginTop: 10 }}>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-jmeno`} label="Jméno" value={this.order.jmeno} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-prijmeni`} label="Příjmení" value={this.order.prijmeni} fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-email`} label="Email" value={this.order.email} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-telefon`} label="Telefon" value={this.order.telefon} fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-ulice`} label="Ulice" value={this.order.ulice} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-mesto`} label="Město" value={this.order.mesto} fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-psc`} label="PSČ" value={this.order.psc} fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-program`} label="Program" value={this.order.program} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-zacatek`} label="Začátek" value={this.order.zacatek} fullWidth />
                                                    </Grid>
                                                </Grid>
                                                <Grid container className="default-margin" spacing={8}>
                                                    <Grid item xs={5}>
                                                        <TextField id={`${this.order.id}-sleva`} label="Sleva" value={this.order.sleva} fullWidth />
                                                    </Grid>
                                                    <Grid item xs={9}>
                                                        <TextField id={`${this.order.id}-poznamka`} label="Poznámka" value={this.order.poznamka} fullWidth multiline />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Grid container item xs={6} >
                                    <Grid item xs={12}>
                                        <Paper square>
                                            <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                                <Toolbar variant="dense">
                                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                    Výběr klienta
                                                </Typography>
                                                <Tooltip title="Přidat klienta" aria-label="Přidat klienta">
                                                    <IconButton color="inherit" aria-label="Přidat klienta" onClick={this.handleNewClient}>
                                                        <AddIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                </Toolbar>
                                            </AppBar>
                                            <Grid container spacing={8} style={{ marginTop: 2 }} >
                                                <Table style={{ margin: 8 }}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell />
                                                            <TableCell>Jméno</TableCell>
                                                            <TableCell>Telefon</TableCell>
                                                            <TableCell>Email</TableCell>
                                                            <TableCell>Adresa</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.clients.map(kl => (
                                                            <TableRow hover key={kl.id}>
                                                                <TableCell><Checkbox checked={this.clientsSelected.get(kl.id)} onChange={this.handleClientCheckedChange(kl.id, true, false)} /></TableCell>
                                                                <TableCell>{kl.jmeno + ' ' + kl.prijmeni}</TableCell>
                                                                <TableCell>{kl.telefon}</TableCell>
                                                                <TableCell>{kl.email}</TableCell>
                                                                <TableCell>{kl.ulice + ' ' + kl.mesto}</TableCell>
                                                            </TableRow>
                                                            ))
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Paper square>
                                            <AppBar position="static" color="secondary" style={{ boxShadow: 'none', backgroundColor: '#90a4ae'}}>
                                                <Toolbar variant="dense">
                                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                                    Parametry turnusu
                                                </Typography>
                                                </Toolbar>
                                            </AppBar>
                                            <Grid container spacing={8} style={{ margin: 8 }} >
                                                <Grid item xs={3}>
                                                    <DatePicker fullWidth label="Počáteční datum" value={this.begining} onChange={this.handleEntityDateValueChange}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField fullWidth label="Program" id="new-den-program" select onChange={this.handleChange('program')} 
                                                        value={this.program}>
                                                            <MenuItem value="none" >Žádný</MenuItem>
                                                            {this.props.ciselnikyStore.getAllValidPrograms().map(prg => (
                                                                <MenuItem value={prg.value}>{prg.value} kJ ({prg.price} Kč/den)</MenuItem>
                                                            ))}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <TextField fullWidth label="Počet turnusů" id="new-den-pocet" select onChange={this.handleChange('pocet')} 
                                                        value={this.pocet}>
                                                            <MenuItem value="1" >1</MenuItem>
                                                            <MenuItem value="2" >2</MenuItem>
                                                            <MenuItem value="3" >3</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <FormControlLabel style={{marginLeft: '15px'}}
                                                        control={<Checkbox checked={this.eko} onChange={this.handleCheckedChange('eko', true, false)} />} 
                                                        label="EKO" />
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <ClientNewDialog open={this.isNewClientDialogOpened} onAdd={this.onClientAdd} onClose={this.onClientDialogClose} clientTemplate={this.clientTemplate} />
                </div>
                : <Typography variant="h5">Nenalezen</Typography>
        )
    }
}

export default withRouter(WebOrderDetail)



// WEBPACK FOOTER //
// ./src/components/WebOrderDetail.tsx